import {Injectable} from "@angular/core";
import {HttpClient, HttpParams} from "@angular/common/http";
import {lastValueFrom} from "rxjs";

@Injectable()
export class UnitMappingService {
  private readonly apiUrl = 'api/UnitMapping';

  constructor(private http: HttpClient) {}

  public getUnitMappingValues(catalogId: string, customerId: string, fields: string[]): Promise<string[]> {
    const url = `${this.apiUrl}/getUnitMappingValues`;
    const params = new HttpParams()
      .append('catalogId', catalogId)
      .append('customerId', customerId)
      .append('fields', fields.join(','));
    const options = { params };
    return lastValueFrom(this.http.get<string[]>(url, options));
  }
}
